import { render, staticRenderFns } from "./ExcelExportSellDebts.vue?vue&type=template&id=32e54fb4"
import script from "./ExcelExportSellDebts.vue?vue&type=script&lang=js"
export * from "./ExcelExportSellDebts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports